import { UserModel } from 'src/app/models/auth/user-model';
import { Injectable, Injector, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject, catchError, map, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';
import { WebService } from './web/web.service';
import { AuthenticationInterface } from '../models/auth/authentication-interface';
import { WebServiceModel } from './web/web-service-model';
import { WebServiceMethod } from './web/web-method';
import { Utils } from '../utils/utils';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AppSessionStorageService } from './utils/session-storage.service';
import { EncryptKeyModel } from '../models/web/encrypt-key.model';
import { CommonService } from './common/common.service';
import { ApiEndPoints } from '../constants/web-constants';
import { RouteConstants } from '../constants/route-constants';
import { DataInterface } from '../models/web/data-interface';
import { GrantAccessModel } from '../models/auth/grant-access-model';
import { StatusInterface } from '../models/web/status-interface';
import { CreateAccountModel } from '../models/create-account.model';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class AuthserviceService {
  private secretKey = 'T7izW0oH8peGIDzKKblHuu0ngyQ4t9R7AHc4j8aqL_8=';
  // Observable for user if authenticated
  private _userAuthenticated: Subject<boolean> = new Subject<boolean>();
  userAuthSuccess$ = this._userAuthenticated.asObservable();
  login_details: any = '';
  cloud_base_url: string = environment.cloud_base_url;
  user_info: any;
  installer_info: any;
  imageToShow: any;
  // Observable for  user Profile
  private _userProfileDetails: Subject<UserModel> = new Subject<UserModel>();
  userProfileDetails$ = this._userProfileDetails.asObservable();
  edit_profile_info: any;
  encrypt_data: any;
  delete_request_info: any;
  verification_status: string = '';
  temporayAuth: AuthenticationInterface | undefined;
  @Input() needAuthToken: boolean = true;
  public webService: WebService | undefined;
  delete_info: any;
  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private storage: StorageService,
    private injector: Injector,
    private sessionStorage: AppSessionStorageService,
    private commonService: CommonService
  ) {
    this.setWebService(injector);
  }

  private async setWebService(injector: Injector) {
    await Utils.delay(500);
    this.webService = injector.get(WebService);
  }
  // function to get user type
  public getUserType(): any {
    return AppSessionStorageService.user?.user_type;
  }
  // function to get refresh token
  public getRefreshToken(): any {
    return AppSessionStorageService.auth?.refresh_token;
  }
  // function to get access token
  public getAccessToken(): any {
    return (
      AppSessionStorageService.auth?.access_token ??
      this.temporayAuth?.access_token
    );
  }
  // function to check logged in or not
  isLoggedIn() {
    return AppSessionStorageService.isLoggedIn();
  }
  // function to clear localstorage after logout
  async logout(): Promise<boolean> {
    if (AppSessionStorageService.auth) {
      const response = await this.webService?.single<EncryptKeyModel>(
        new WebServiceModel(ApiEndPoints.SIGNOUT, WebServiceMethod.Delete)
      );
      if ((response?.success ?? false) || response?.responseCode == 422) {
        localStorage?.clear();
        sessionStorage?.clear();
        if (response?.responseCode != 422) {
          this.commonService.updateKey(response?.data);
        }

        this.injector.get(AppSessionStorageService).removeToken();
        this.router.navigate([RouteConstants.SIGNIN], {
          replaceUrl: true,
        });
        if (response?.responseCode == 422) {
          location.reload();
        }
        return true;
      }
    }
    return false;
  }
  // function to check if an user in logged in or not
  public isAuthenticated(): boolean {
    return this.isLoggedIn();
  }

  //API CALL TO SIGNIN
  public async login(user_details: {
    username: string | null;
    password: string | null;
    location: string;
  }) {
    const response = await this.webService?.single<AuthenticationInterface>(
      new WebServiceModel(
        ApiEndPoints.SIGN_IN,
        WebServiceMethod.Post,
        user_details,
        false
      )
    );
    return response;
  }

  //API CALL FOR CHNAGE PASSWORD
  public async changePassword(payload:any) {
    const response = await this.webService?.single<AuthenticationInterface>(
      new WebServiceModel(
        ApiEndPoints.CHANGE_PASSWORD,
        WebServiceMethod.Put,
        payload,
        false
      )
    );
    return response;
  }

  async setLoginCredentials(
    auth: AuthenticationInterface | undefined | null
  ): Promise<string | null> {
    if (auth) {
      this.injector.get(AppSessionStorageService)?.setToken(auth, true);
      this.commonService.setupMqtt(auth?.webhook);
      const userDetails = await this.fetchUserDetails();
      //check to redirect end user to corresponding dashboard
      if (userDetails?.success ?? false) {
        if (this.getUserType() == 'installer' && this.verification_status) {
          this.router.navigate(['installer'], { replaceUrl: true });
        } else if (this.getUserType() == 'administrator') {
          this.router.navigate(['admin'], { replaceUrl: true });
        } else {
          await this.logout();
          return 'Not a verified installer';
        }
      } else {
        await this.logout();
      }
    }
    return null;
  }

  // API CALL TO GET ALL USER LIST TO LIST DOWN IN INSTALLER DASHBOARD
  public async getUserList() {
    const response = await this.webService?.list(
      new WebServiceModel(ApiEndPoints.USER_LIST, WebServiceMethod.Post, {})
    );
    return response?.data ?? [];
  }

  // API CALL TO GET ALL USER LIST TO LIST DOWN IN ADMIN DASHBOARD
  public async getInstallerList() {
    const response = await this.webService?.list(
      new WebServiceModel(ApiEndPoints.INSTALLER_LIST, WebServiceMethod.Get)
    );
    return response?.data ?? [];
  }

  //API CALL TO GET REDFRESH TOKEN
  public async refeshToken() {
    const response = await this.webService?.single<AuthenticationInterface>(
      new WebServiceModel(ApiEndPoints.REFRESH_TOKEN, WebServiceMethod.Get)
    );
    if (response?.data) {
      this.injector
        .get(AppSessionStorageService)
        ?.setToken(response.data, true);
    }
  }

  // API CALL TO GET USER DEATILS
  public async fetchUserDetails(): Promise<
    DataInterface<UserModel> | undefined
  > {
    this.webService ??= this.injector.get(WebService);
    const response = await this.webService?.single<UserModel>(
      new WebServiceModel(ApiEndPoints.USER_DETAILS, WebServiceMethod.Get)
    );
    if (response?.success ?? false) {
      const user = response?.data;
      this.sessionStorage.setUser(user);
      this.user_info = AppSessionStorageService.user;
      this.commonService.subscribeMqttTopic(user?.user_id ?? '');
      if (this.user_info.additional_info) {
        this.verification_status = JSON.stringify(
          this.user_info.additional_info.verification_status
        );
      }

      // condition to check to avoid type error for user with no profile image
      if (this.user_info.files_id) {
        this.fetchImageFromService(this.user_info.files_id);
      }
    }
    return response;
  }
  // function to get user details
  public getUserDetails() {
    return AppSessionStorageService.user;
  }

  private async getImage(url: string): Promise<any> {
    try {
      const response = await this.webService?.loadImage(
        ApiEndPoints.IMAGE + url,
        this.needAuthToken
      );
      return response?.data ?? [];
    } catch (_) {}
    return '';
  }

  // fucntion to create the image response to blob for dispalying as profile picture
  createImageFromBlob(image: Blob) {
    let reader = new FileReader();

    reader.addEventListener(
      'load',
      () => {
        this.imageToShow = reader.result;
        this.storage.saveToLocalStorage('ProfileImage', this.imageToShow);

        if (AppSessionStorageService.user) {
          // Reinitiating request to make sure to load image in main page
          this._userProfileDetails.next(AppSessionStorageService.user);
        }
      },
      false
    );

    if (image) {
      reader.readAsDataURL(image);
    }
  }
  // fetching image
  async fetchImageFromService(imageUrl: string) {
    let dynamicPart = '';
    const regex = /\/image\/(.+)/;
    const match = regex.exec(imageUrl);
    if (match && match.length > 1) {
      dynamicPart = match[1];
    }
    const response = await this.getImage(dynamicPart);
    this.createImageFromBlob(response);
  }

  // getting save d profile image from local storage
  public getUserImage() {
    return this.storage.getFromLocalStorage('ProfileImage');
  }

  // API CALL TO UPDATED USER STATUS LIKE ACTIVE ALL USER AND VERIFICATION STATUS FOR ONLY INSTALLER
  // Note:- INSTALLER SPECIFIC API
  public async UpdateUserData(data: {
    user_id:string;
    status: string;
    verification_status: any;
  }):Promise<StatusInterface> {
    const user_data = data;
    return this.webService?.status(
      new WebServiceModel(
        ApiEndPoints.UPDATE_USER_STATUS,
        WebServiceMethod.Post,
        user_data,
      )
    )?? new StatusInterface();
  }

  // API FOR PROFILE EDIT
  async editProfile(updatedDetails: any,profileImage:any) {
     const webModel =  new WebServiceModel(
        ApiEndPoints.UPDATE_USER_DETAILS,
        WebServiceMethod.Patch,
        updatedDetails,
        true,
        true
      )
      if(profileImage){
      webModel.addFile('profile_picture',profileImage)
      }
      const response = this.webService?.single(webModel)
    return response;
  }

    //API TO REQUEST OTP FOR ACCOUNT DELETE
  public async delete_account_request(
    user_details: any,
    token: any
  ){
    const encrypt_detials = await this.encrypt(user_details);
    let payload = {
      data:encrypt_detials,
      captcha_token:token
    }
    const webModel = new WebServiceModel(
      ApiEndPoints.ACCOUNT_DELETE,WebServiceMethod.Post,
      payload,
      false
    );
    const response = this.webService?.single(webModel)
    return response
  }

  // API TO DELETE ACCOUNT AFTER RECIEVING API THEOUGH MAIL.
  public async delete_account(user_details:any,token:any){
    const encrypt_detials = await this.encrypt(user_details);
    let payload = {
      data:encrypt_detials,
      captcha_token:token
    }
    const webModel = new WebServiceModel(ApiEndPoints.ACCOUNT_DELETE,WebServiceMethod.Delete,payload,false);
    const response = this.webService?.single(webModel)
    return response
  }

  // ENCRYPTION FUNCTION TO ENCRYPT END USER SPECIFIC DATA FOR SENDING AS API REQUEST BODY
  async encrypt(data: any): Promise<string> {
    return this.commonService.encrypt(data) ?? '';
  }

  // FUNCTION TO DECRYPT RECIEVED ENCRYPTED DATA
  async decrypt(encryptedData: any): Promise<any> {
    return this.commonService.decryptData(encryptedData) ?? '';
  }
  // FUNCTION TO ENCRYPT DATA FOR FORM DATA
  async encrypt_form_data(data: any): Promise<string> {
    return this.commonService.encrypt(data) ?? '';
  }
  // FUNCTION TO DECRYPT ENCRYPTED REQUEST PARAMS IN HEADER
  async decrypt_params(encryptedData: any): Promise<any> {
    return this.commonService.decryptData(encryptedData) ?? '';
  }

  // fucntion to create the image response to blob for dispalying as profile picture
  createImage(image: Blob, files_id: string) {
    let reader = new FileReader();

    reader.addEventListener(
      'load',
      () => {
        this.imageToShow = reader.result;
        this.storage.saveToLocalStorage(files_id, this.imageToShow);
      },
      false
    );
    if (image) {
      reader.readAsDataURL(image);
    }
  }
  async fetchImage(installer_list: any) {
    for (const installer of installer_list) {
      if (installer?.files_id) {
        const response = this.getImage(installer.files_id);
        this.createImage(await response, installer.files_id);
      }
    }
  }

  async adminGrantAccess(installer: any) {
    const response = await this.webService?.single<GrantAccessModel>(
      new WebServiceModel(
        ApiEndPoints.INSTALLER_VIEW_ACCESS,
        WebServiceMethod.Post,
        { user_id: installer.user_id }
      )
    );
    return response;
  }

  async accessLogging(data:any) {
    const response = await this.webService?.single<any>(
      new WebServiceModel(
        ApiEndPoints.ACCESS_LOGGER,
        WebServiceMethod.Post,
        data
      )
    );
    return response;
  }

  getInstallerImages(files_id: string) {
    return this.storage.getFromLocalStorage(files_id);
  }

  saveCurrentInstallerDetails(installer_details: any) {
    this.storage.saveToLocalStorage(
      'current_installer',
      JSON.stringify(installer_details)
    );
    return null;
  }
  getCurrentInstallerDetails() {
    return this.storage.getFromLocalStorage('current_installer');
  }
  removeCurrentInstallerDetails() {
    this.storage.removeFromLocalStorage('current_installer');
    return null;
  }

  localStorageHandler() {
    this.storage.saveToLocalStorage('message', 'Not a verified installer');
    this.storage.removeFromLocalStorage('aiowt');
    this.storage.removeFromLocalStorage('aiorwt');
    this.storage.removeFromLocalStorage('UserDetails');
    this.storage.removeFromLocalStorage('current_installer');
  }



  encryptParams(value: string): string {
    return CryptoJS.AES.encrypt(value, this.secretKey).toString();
  }

  decryptParams(cipherText: string): string {
    const bytes = CryptoJS.AES.decrypt(cipherText, this.secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  }




    async createAccount(input: CreateAccountModel): Promise<StatusInterface> {
    const data = { ...input};
    delete data.confirmPasswordError;
    delete data.passwordError;
    delete data.oldPasswordError;
    delete data.oldPassword;
    delete data.confirmPassword;
    delete data.zip_code;
    const finalData = { ...data, ...data.address };
    const requestModel = new WebServiceModel(
      ApiEndPoints.CREATE_ACCOUNT,
      WebServiceMethod.Post,
      finalData,
      false
    );

    const response = this.webService?.status(requestModel);
    return response ?? new StatusInterface();
  }
}
